var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex", staticStyle: { height: "20px" } },
    [
      _c(
        "v-list-item-avatar",
        { staticClass: "my-0 mr-1", attrs: { size: "20" } },
        [
          _c("v-img", {
            attrs: {
              src: _vm.arg.event.extendedProps.teacher.profile_photo_path
                ? `/api/image-service/20x20/${_vm.arg.event.extendedProps.teacher.profile_photo_path}`
                : _vm.arg.event.extendedProps.teacher.profile_photo_url,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-list-item-content", { staticClass: "mr-3 font-bold" }, [
        _c("small", [_vm._v(_vm._s(_vm.arg.event.title))]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }